import { SEOHead } from "@/components/SEOHead";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { SEOContentBlock } from "@/components/seo/SEOContentBlock";
import { seoCopy } from "@/content/seoCopy";

const Specials = () => {
  return (
    <div className="min-h-screen">
      <SEOHead
        title="Specials & Deals on Cabanas, Tubing & Glamping Near New Braunfels"
        description="Save on cabana rentals near New Braunfels, tubing the Guadalupe River, and glamping deals. Limited-time specials on family getaways near New Braunfels, TX."
        canonical="/specials"
      />
      <Header />
      <main className="pt-24">
        <section className="section-padding bg-background">
          <div className="container-narrow mx-auto text-center">
            <h1 className="font-heading text-4xl md:text-5xl font-bold text-foreground mb-6">
              Deals & Specials
            </h1>
            <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
              Check back for current specials and promo codes on Guadalupe River cabanas, tubing & glamping.
            </p>
          </div>
        </section>
      </main>
      <SEOContentBlock {...seoCopy.specials} />
      <Footer />
    </div>
  );
};

export default Specials;
